import * as types from './types';

export const mutations = {
  [types.SET_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CONVERSATIONS](_state, data) {
    _state.records = data;
  },
  [types.ADD_CONVERSATION](_state, data) {
    const idx = _state.records.findIndex(c => c.id === data.id);
    if (idx !== -1) {
      _state.records.splice(idx, 1, data);
    } else {
      _state.records.unshift(data); // Prepend so new convos appear at top
    }
  },
  [types.UPDATE_CONVERSATION](_state, data) {
    const idx = _state.records.findIndex(c => c.id === data.id);
    if (idx !== -1) {
      _state.records[idx] = data;
    }
  },
  [types.REMOVE_CONVERSATION](_state, id) {
    _state.records = _state.records.filter(c => c.id !== id);
  },
  [types.SET_MESSAGES](_state, { conversationId, messages }) {
    _state.messages[conversationId] = messages;
  },
  [types.ADD_MESSAGE](_state, { conversationId, message }) {
    if (!_state.messages[conversationId]) {
      _state.messages[conversationId] = [];
    }
    const exists = _state.messages[conversationId].some(
      m => m.id === message.id
    );
    if (!exists) {
      _state.messages[conversationId].push(message);
    }
  },
  [types.UPDATE_MESSAGE](_state, { conversationId, message }) {
    if (!_state.messages[conversationId]) return;
    const idx = _state.messages[conversationId].findIndex(
      m => m.id === message.id
    );
    if (idx !== -1) {
      _state.messages[conversationId][idx] = message;
    }
  },
  [types.REMOVE_MESSAGE](_state, { conversationId, messageId }) {
    if (!_state.messages[conversationId]) return;
    _state.messages[conversationId] = _state.messages[conversationId].filter(
      m => m.id !== messageId
    );
  },
  [types.SET_SUPERVISED_CONVERSATIONS](_state, data) {
    _state.supervisedConversations = data;
  },
  [types.SET_SUPERVISED_USER](_state, data) {
    _state.supervisedUser = data;
  },
};
